<template>
  <div v-if="memberIdentity !== null && memberIdentity !== undefined">
    <v-dialog scrollable max-width="1200" v-model="model">
      <material-card
        :title="$t('components.benefit_cards_dialog.title', [memberName])"
        :color="$vuetify.theme.themes.light.secondary"
        icon="credit_card"
      >
        <template #actions>
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="margin: 0.25rem"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
                Actions
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="printAll()">
                <v-list-item-title>
                  <v-icon>print</v-icon>
                  {{ $t("components.benefit_cards_dialog.print_all") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadAll()">
                <v-list-item-title>
                  <v-icon>file_download</v-icon>
                  {{ $t("components.benefit_cards_dialog.download_all") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="memberIdentity.Email"
                @click="showConfirmDialog(cards)"
              >
                <v-list-item-title>
                  <v-icon>mail</v-icon>
                  {{ $t("components.benefit_cards_dialog.send_all") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <v-card-text>
          <div style="margin: 0 auto; text-align: center" v-if="cards === null">
            <v-progress-circular color="primary" indeterminate />
          </div>
          <div v-else-if="cards.length === 0">
            <p>{{ $t("components.memberview.no_cards_found") }}</p>
          </div>
          <v-row v-else>
            <v-col
              cols="12"
              md="6"
              lg="4"
              v-for="card of cards"
              :key="card.Id"
              style="text-align: center"
            >
              <div>
                <span>{{ card.Name }}</span>
              </div>
              <div>
                <img
                  :src="card.Source"
                  style="
                    max-height: 250px;
                    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
                  "
                />
              </div>

              <v-btn
                style="margin-right: 10px"
                color="primary"
                @click="printImage(card)"
              >
                <v-icon>print</v-icon>
                {{ $t("globals.print") }}
              </v-btn>
              <v-btn
                style="margin-right: 10px"
                dark
                color="success"
                @click="downloadCard(card)"
              >
                <v-icon>file_download</v-icon>
                {{ $t("globals.download") }}
              </v-btn>
              <v-btn
                v-if="memberIdentity.Email"
                dark
                color="primary"
                @click="showConfirmDialog([card])"
              >
                <v-icon>mail</v-icon>
                {{ $t("globals.send") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog max-width="600" v-model="showEmailConfirmationDialog">
      <material-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="mail"
        :title="
          $t('components.benefit_cards_dialog.confirm_title', [memberName])
        "
      >
        <v-card-text>
          {{ $t("components.benefit_cards_dialog.confirm_msg", [memberName]) }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="showEmailConfirmationDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            v-if="memberIdentity.Email"
            :loading="loading"
            @click="sendEmail()"
            color="primary"
          >
            {{ $t("components.membersmanagementtable.send_email") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
    <!-- <v-snackbar v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar> -->
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import PrintService from "../../services/print.service";
import ErrorHandler from "../../components/ErrorHandler";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["title", "cards", "model", "memberIdentity", "memberOdataQuery"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      error: null,
      loading: false,
      snackbarText: "",
      showEmailConfirmationDialog: false,
      card: null,
      cardsToSend: [],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["planIdentity"]),
    memberName() {
      if (!this.memberIdentity) {
        return "";
      } else if (this.memberIdentity.CurrentMember) {
        const { FirstName, LastName } = this.memberIdentity.CurrentMember;
        return `${FirstName} ${LastName}`.trim();
      } else if (this.memberIdentity.MemberIdentification.Certificate) {
        return this.memberIdentity.MemberIdentification.Certificate;
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapActions("plansMembers", ["getMemberInfo"]),
    ...mapActions("downloadCenter", ["getMemberBenefitCards"]),
    ...mapActions("portalsProxy", ["getPlanPortalConfiguration"]),
    downloadAll() {
      for (let card of this.cards) {
        this.downloadCard(card);
      }
    },
    mergeDependants(depList1, depList2) {
      const res = [].concat(depList1);
      for (let dep of depList2) {
        if (
          depList1.filter((o) => o.IdentityId === dep.IdentityId).length === 0
        ) {
          res.push(dep);
        }
      }
      return res;
    },
    async sendEmail() {
      this.loading = true;
      const query =
        this.memberOdataQuery +
        ",CurrentActiveMemberBenefits($expand=CurrentBenefit($expand=Translations)),CurrentDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentMedicalEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentHealthEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentDentalEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentDrugsEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentTravelEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible))";
      try {
        const member = (
          await this.getMemberInfo({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.memberIdentity.Id,
            odataQuery: query,
          })
        ).data;

        const ids = member.CurrentActiveMemberBenefits.map(
          (o) => o.CoverageIdentityId
        );
        const filters = [];
        for (const id of ids) {
          filters.push(`(Coverages/any(_e: _e/CoverageId eq ${id}))`);
        }
        const cardsQuery = `?$expand=Coverages&$select=Id&$filter=${filters.join(
          " or "
        )}`;
        const memberCards = (
          await this.getMemberBenefitCards({
            planIdentityId: this.selectedPlan.Id,
            odataQuery: cardsQuery,
          })
        ).data.value;

        let language = "en";
        // if (member.CurrentContactInformation) {
        //   member.CurrentContactInformation.LanguageChoice &&
        //   member.CurrentContactInformation.LanguageChoice.Name === "French"
        //     ? "fr"
        //     : "en";
        // }
        let currentDependants = {};
        member.CurrentDependants = member.CurrentDependants.filter(
          (o) => o.Identity.IsEligible
        ).sort((a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code));

        currentDependants.Code = member.CurrentDependants.map(
          (o) => o.Identity.Code
        ).join("\r\n");
        currentDependants.Relationship = member.CurrentDependants.map(
          (o) =>
            o.Relationship.Translations.filter(
              (o) => o.LanguageCode === this.language.language
              )[0].DisplayValue
        ).join("\r\n");
        currentDependants.FullName = member.CurrentDependants.map(
          (o) => o.FirstName + " " + Array.from(o.LastName)[0]
        ).join("\r\n");
        member.CurrentDependants = currentDependants;
        let transMember = JSON.parse(JSON.stringify(member));
        transMember.CurrentHealthAndDentalDependants = this.mergeDependants(
          transMember.CurrentHealthEligibleDependants,
          transMember.CurrentDentalEligibleDependants
        ).sort((a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code));

        currentDependants.Code =
          transMember.CurrentHealthAndDentalDependants.map(
            (o) => o.Identity.Code
          ).join("\r\n");
        currentDependants.Relationship =
          transMember.CurrentHealthAndDentalDependants.map(
            (o) =>
              o.Relationship.Translations.filter(
                (o) => o.LanguageCode === language
              )[0].DisplayValue
          ).join("\r\n");
        currentDependants.FullName =
          transMember.CurrentHealthAndDentalDependants.map(
            (o) => o.FirstName + " " + Array.from(o.LastName)[0]
          ).join("\r\n");

        for (let i = 0; i < 8; i++) {
          if (i < transMember.CurrentHealthAndDentalDependants.length) {
            currentDependants[`FullInfo${i + 1}`] = `${
              transMember.CurrentHealthAndDentalDependants[i].Identity.Code
            } ${transMember.CurrentHealthAndDentalDependants[i].FirstName} ${
              transMember.CurrentHealthAndDentalDependants[i].LastName
            }, ${
              transMember.CurrentHealthAndDentalDependants[
                i
              ].Relationship.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].DisplayValue
            }`;

            if (
              transMember.CurrentHealthEligibleDependants.filter(
                (o) =>
                  o.IdentityId ===
                  transMember.CurrentHealthAndDentalDependants[i].IdentityId
              ).length > 0 &&
              transMember.CurrentDentalEligibleDependants.filter(
                (o) =>
                  o.IdentityId ===
                  transMember.CurrentHealthAndDentalDependants[i].IdentityId
              ).length > 0
            ) {
              currentDependants[`Status${i + 1}`] = "";
            } else if (
              transMember.CurrentDentalEligibleDependants.filter(
                (o) =>
                  o.IdentityId ===
                  transMember.CurrentHealthAndDentalDependants[i].IdentityId
              ).length > 0
            ) {
              currentDependants[`Status${i + 1}`] = "Dental Only";
            } else {
              currentDependants[`Status${i + 1}`] = "Health Only";
            }
          } else {
            currentDependants[`FullInfo${i + 1}`] = "";
            currentDependants[`Status${i + 1}`] = "";
          }
        }
        transMember.CurrentHealthAndDentalDependants = JSON.parse(
          JSON.stringify(currentDependants)
        );
        console.log(
          JSON.stringify(transMember.CurrentHealthAndDentalDependants)
        );

        transMember.CurrentHealthDependants =
          transMember.CurrentHealthEligibleDependants.sort(
            (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
          );

        currentDependants = {};
        currentDependants.Code = transMember.CurrentHealthDependants.map(
          (o) => o.Identity.Code
        ).join("\r\n");
        currentDependants.Relationship =
          transMember.CurrentHealthDependants.map(
            (o) =>
              o.Relationship.Translations.filter(
                (o) => o.LanguageCode === language
              )[0].DisplayValue
          ).join("\r\n");
        currentDependants.FullName = transMember.CurrentHealthDependants.map(
          (o) => o.FirstName + " " + Array.from(o.LastName)[0]
        ).join("\r\n");

        for (let i = 0; i < 8; i++) {
          if (i < transMember.CurrentHealthDependants.length) {
            currentDependants[`FullInfo${i + 1}`] = `${
              transMember.CurrentHealthDependants[i].Identity.Code
            } ${transMember.CurrentHealthDependants[i].FirstName} ${
              transMember.CurrentHealthDependants[i].LastName
            }, ${
              transMember.CurrentHealthDependants[
                i
              ].Relationship.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].DisplayValue
            }`;
          } else {
            currentDependants[`FullInfo${i + 1}`] = "";
          }
        }
        transMember.CurrentHealthDependants = JSON.parse(
          JSON.stringify(currentDependants)
        );
        console.log(JSON.stringify(transMember.CurrentHealthDependants));

        transMember.CurrentMedicalDependants =
          transMember.CurrentMedicalEligibleDependants.sort(
            (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
          );

        currentDependants = {};
        currentDependants.Code = transMember.CurrentMedicalDependants.map(
          (o) => o.Identity.Code
        ).join("\r\n");
        currentDependants.Relationship =
          transMember.CurrentMedicalDependants.map(
            (o) =>
              o.Relationship.Translations.filter(
                (o) => o.LanguageCode === language
              )[0].DisplayValue
          ).join("\r\n");
        currentDependants.FullName = transMember.CurrentMedicalDependants.map(
          (o) => o.FirstName + " " + Array.from(o.LastName)[0]
        ).join("\r\n");

        for (let i = 0; i < 8; i++) {
          if (i < transMember.CurrentMedicalDependants.length) {
            currentDependants[`FullInfo${i + 1}`] = `${
              transMember.CurrentMedicalDependants[i].Identity.Code
            } ${transMember.CurrentMedicalDependants[i].FirstName} ${
              transMember.CurrentMedicalDependants[i].LastName
            }, ${
              transMember.CurrentMedicalDependants[
                i
              ].Relationship.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].DisplayValue
            }`;
          } else {
            currentDependants[`FullInfo${i + 1}`] = "";
          }
        }
        transMember.CurrentMedicalDependants = JSON.parse(
          JSON.stringify(currentDependants)
        );
        console.log(JSON.stringify(transMember.CurrentMedicalDependants));

        transMember.CurrentDentalDependants =
          transMember.CurrentDentalEligibleDependants.sort(
            (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
          );

        currentDependants = {};
        currentDependants.Code = transMember.CurrentDentalDependants.map(
          (o) => o.Identity.Code
        ).join("\r\n");
        currentDependants.Relationship =
          transMember.CurrentDentalDependants.map(
            (o) =>
              o.Relationship.Translations.filter(
                (o) => o.LanguageCode === language
              )[0].DisplayValue
          ).join("\r\n");
        currentDependants.FullName = transMember.CurrentDentalDependants.map(
          (o) => o.FirstName + " " + Array.from(o.LastName)[0]
        ).join("\r\n");

        for (let i = 0; i < 8; i++) {
          if (i < transMember.CurrentDentalDependants.length) {
            currentDependants[`FullInfo${i + 1}`] = `${
              transMember.CurrentDentalDependants[i].Identity.Code
            } ${transMember.CurrentDentalDependants[i].FirstName} ${
              transMember.CurrentDentalDependants[i].LastName
            }, ${
              transMember.CurrentDentalDependants[
                i
              ].Relationship.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].DisplayValue
            }`;
          } else {
            currentDependants[`FullInfo${i + 1}`] = "";
          }
        }
        transMember.CurrentDentalDependants = JSON.parse(
          JSON.stringify(currentDependants)
        );
        console.log(JSON.stringify(transMember.CurrentDentalDependants));

        transMember.CurrentTravelDependants =
          transMember.CurrentTravelEligibleDependants.sort(
            (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
          );

        currentDependants = {};
        currentDependants.Code = transMember.CurrentTravelDependants.map(
          (o) => o.Identity.Code
        ).join("\r\n");
        currentDependants.Relationship =
          transMember.CurrentTravelDependants.map(
            (o) =>
              o.Relationship.Translations.filter(
                (o) => o.LanguageCode === language
              )[0].DisplayValue
          ).join("\r\n");
        currentDependants.FullName = transMember.CurrentTravelDependants.map(
          (o) => o.FirstName + " " + Array.from(o.LastName)[0]
        ).join("\r\n");

        for (let i = 0; i < 8; i++) {
          if (i < transMember.CurrentTravelDependants.length) {
            currentDependants[`FullInfo${i + 1}`] = `${
              transMember.CurrentTravelDependants[i].Identity.Code
            } ${transMember.CurrentTravelDependants[i].FirstName} ${
              transMember.CurrentTravelDependants[i].LastName
            }, ${
              transMember.CurrentTravelDependants[
                i
              ].Relationship.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].DisplayValue
            }`;
          } else {
            currentDependants[`FullInfo${i + 1}`] = "";
          }
        }
        transMember.CurrentTravelDependants = JSON.parse(
          JSON.stringify(currentDependants)
        );
        console.log(JSON.stringify(transMember.CurrentTravelDependants));

        transMember.CurrentDrugsDependants =
          transMember.CurrentDrugsEligibleDependants.sort(
            (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
          );

        currentDependants = {};
        currentDependants.Code = transMember.CurrentDrugsDependants.map(
          (o) => o.Identity.Code
        ).join("\r\n");
        currentDependants.Relationship = transMember.CurrentDrugsDependants.map(
          (o) =>
            o.Relationship.Translations.filter(
              (o) => o.LanguageCode === language
            )[0].DisplayValue
        ).join("\r\n");
        currentDependants.FullName = transMember.CurrentDrugsDependants.map(
          (o) => o.FirstName + " " + Array.from(o.LastName)[0]
        ).join("\r\n");

        for (let i = 0; i < 8; i++) {
          if (i < transMember.CurrentDrugsDependants.length) {
            currentDependants[`FullInfo${i + 1}`] = `${
              transMember.CurrentDrugsDependants[i].Identity.Code
            } ${transMember.CurrentDrugsDependants[i].FirstName} ${
              transMember.CurrentDrugsDependants[i].LastName
            }, ${
              transMember.CurrentDrugsDependants[
                i
              ].Relationship.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].DisplayValue
            }`;
          } else {
            currentDependants[`FullInfo${i + 1}`] = "";
          }
        }
        transMember.CurrentDrugsDependants = JSON.parse(
          JSON.stringify(currentDependants)
        );
        console.log(JSON.stringify(transMember.CurrentDrugsDependants));

        let currentActiveBenefits = [];
        for (const benefit of transMember.CurrentActiveMemberBenefits) {
          for (const card of memberCards) {
            if (
              card.Coverages.filter(
                (c) => c.CoverageId === benefit.CoverageIdentityId
              ).length > 0
            ) {
              currentActiveBenefits.push(benefit);
              break;
            }
          }
        }
        console.log(currentActiveBenefits);
        transMember.ActiveMemberBenefits = currentActiveBenefits
          .map(
            (o) =>
              o.CurrentBenefit.Translations.filter(
                (t) => t.LanguageCode === language
              )[0].Name
          )
          .join(", ");
        if (transMember.CurrentMember.FirstName) {
          transMember.CurrentMember.FirstName =
            transMember.CurrentMember.FirstName.toUpperCase();
        }
        if (transMember.CurrentMember.LastName) {
          transMember.CurrentMember.LastName =
            transMember.CurrentMember.LastName.toUpperCase();
        }
        if (transMember.CurrentMember.MiddleName) {
          transMember.CurrentMember.MiddleName =
            transMember.CurrentMember.MiddleName.toUpperCase();
        }

        const payload = {
          Email: this.memberIdentity.Email,
          CardArguments: transMember,
          FirstName: this.memberIdentity.CurrentMember.FirstName,
          LastName: this.memberIdentity.CurrentMember.LastName,
          BenefitCardIds: this.cardsToSend.map((c) => c.Id),
          Language:
            this.memberIdentity.CurrentContactInformation &&
            this.memberIdentity.CurrentContactInformation.LanguageChoice
              ? this.memberIdentity.CurrentContactInformation.LanguageChoice
                  .Name
              : "English",
        };
        let url = "/cms/BenefitCardsEmail";
        if (
          !this.planIdentity.HasDrupalPortal &&
          this.planIdentity.MembersPortal &&
          this.planIdentity.MembersPortal.IsActive
        ) {
          url = "cms/plans/" + this.selectedPlan.Id + "/BenefitCards/SendEmail";
        }
        const portalConfig = (await this.getPlanPortalConfiguration({planIdentityId: this.selectedPlan.Id})).data;
        payload.PlanName = portalConfig.Json.planAdministrator;
        payload.SupportEmail = this.language === "fr" ? portalConfig.Json.adminEmailRecipients.Fr[0] : portalConfig.Json.adminEmailRecipients.En[0],
        payload.PlanPortal = `https://${portalConfig.Domain}`;
        await ApiService.post(url, payload);
        this.color = "success";
        this.message = "globals.success";
        // this.snackbarText = this.$t(
        //   "components.benefit_cards_dialog.email_success"
        // );
        this.snackbar = true;
      } catch (error) {
        // this.snackbarText = this.$t(
        //   "components.benefit_cards_dialog.email_fail"
        // );
        // let error = new Error();
        error.customMessage = this.$t(
          "components.benefit_cards_dialog.email_fail"
        );
        this.error = error;
      }
      this.loading = false;
      this.showEmailConfirmationDialog = false;
    },
    showConfirmDialog(cardsToSend) {
      this.showEmailConfirmationDialog = true;
      this.cardsToSend = cardsToSend;
    },
    downloadCard(card) {
      const linkSource = card.Source;
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      downloadLink.href = linkSource;
      downloadLink.target = "_self";
      downloadLink.download = card.Name;
      downloadLink.click();
      downloadLink.remove();
    },
    printImage(card) {
      var img = document.createElement("img");
      img.src = card.Source;
      img.style = `width: ${card.Width}in; height: ${card.Height}in`;
      PrintService.printElement(img);
    },
    printAll() {
      const root = document.createElement("div");
      this.cards.forEach((card) => {
        var img = document.createElement("img");
        img.src = card.Source;
        img.style = `width: ${card.Width}in; height: ${card.Height}in`;
        root.appendChild(img);
      });
      PrintService.printElement(root);
    },
  },
};
</script>

<style></style>
